/* global I18n  */

import userSettings from "./user_settings"
import vimeoManager from "./vimeo_manager"

export default {
  show: (iframe) => {
    if (captionsDisabled()) return Promise.resolve()
    return setCurrentLanguageCaptions(iframe).catch(() =>
      // default to captions of the language of the video when no captions based
      // on the user settings could be found
      setVideoLanguageCaptions(iframe)
    )
  },

  onChange: (language) => {
    const settings = userSettings.get("site") || {}
    if (settings.currentVideoCaptions) {
      settings[`${settings.currentVideoCaptions}CaptionsDisabled`] = true
    }

    if (language) settings[`${language}CaptionsDisabled`] = false
    settings.currentVideoCaptions = language || null
    return userSettings.register({site: settings})
  }
}

function captionsDisabled() {
  return userSettings.get("site")?.currentVideoCaptions === null
}

function setCurrentLanguageCaptions(iframe) {
  const settings = userSettings.get("site") || {}
  // if user has disabled the captions completely
  if (settings.currentVideoCaptions === null) {
    return Promise.resolve()
  // try users video captions settings for this video if it exists
  } else if (settings.currentVideoCaptions) {
    return vimeoManager.enableCaptions(
      iframe,
      settings.currentVideoCaptions
    )
  // use locale when user hasn't set any video captions yet and isn't disabled
  } else if (!settings?.[`${I18n.locale}CaptionsDisabled`]) {
    return vimeoManager.enableCaptions(iframe, I18n.locale)
  }
  return Promise.resolve()
}

function setVideoLanguageCaptions(iframe) {
  const language = vimeoManager.getVideoLanguage(iframe)
  if (!language) return Promise.resolve()
  const settings = userSettings.get("site") || {}
  if (settings[`${language}CaptionsDisabled`]) return Promise.resolve()
  return vimeoManager.enableCaptions(iframe, language).catch(() =>
    Promise.resolve()
  )
}
